const View = require('app/scripts/views/internal/view');

const template = require('app/scripts/views/templates/footer_chrome');

class Footer extends View {
  static initClass() {
    this.prototype.className = 'embedded-board-footer';
  }

  render() {
    this.$el.html(
      template({
        url: this.options.url,
      }),
    );
    return this;
  }
}

Footer.initClass();
module.exports = Footer;
